import { getConfig } from './runtime'

export const getAlgoliaApplicationId = (): string => getConfig().algolia.applicationId
export const getAlgoliaSearchApiKey = (): string => getConfig().algolia.searchApiKey
export const isAlgoliaEnabled = (): boolean => getConfig().algolia.searchEnable
